import { api, IFindAllRepository } from "../@vendor/utils";
import axios from "../@vendor/utils/services/api.service";
import { ScheduleTime } from "../models/Schedule";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

interface IScheduleRepository<T> extends IFindAllRepository<T> {}

// Keyed cancel tokens so concurrent requests with different keys don't cancel each other
const _scheduleTimeCancelSources: Record<string, any> = {};
const _buildKey = (params: any) => {
  const { psychologist_id, type, date, duration, session_type } = params || {};
  return `${psychologist_id || ""}|${type || ""}|${date || ""}|${duration || ""}|${session_type || "ASSESSMENT"}`;
};

const _getCancelTokenFor = (key: string) => {
  // Only cancel the previous request for the same key
  const prev = _scheduleTimeCancelSources[key];
  if (prev) {
    try {
      prev.cancel && prev.cancel(`${key} canceled`);
    } catch {}
  }
  const source = axios.CancelToken.source();
  _scheduleTimeCancelSources[key] = source;
  return source.token;
};

const ScheduleTimeRepository: IScheduleRepository<ScheduleTime> = {
  findAll: function (params) {
    const key = _buildKey(params);
    return api.get(`${endPoint()}/api/schedule-time`, {
      params,
      cancelToken: _getCancelTokenFor(key),
    });
  },
};

export default ScheduleTimeRepository;
